/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type RiskDto = {
    /**
     * Risk ID (UUID). Used for updating risks. If not provided, a new risk will be created.
     */
    id?: string;
    /**
     * External risk reference sent to Ando. Use quote_risks UUID for stable risk identity.
     */
    external_risk_reference?: string;
    /**
     * Type of the risk. Accepts either Ando labels (e.g., "PERSONAL LINES - HOME RISK") or compact values (HOUSE/CONTENTS/VEHICLE).
     */
    risk_type: RiskDto.risk_type;
    /**
     * Offering
     */
    offering: RiskDto.offering;
    /**
     * Risk details (Ando shape)
     */
    risk_details: Record<string, any>;
};
export namespace RiskDto {
    /**
     * Type of the risk. Accepts either Ando labels (e.g., "PERSONAL LINES - HOME RISK") or compact values (HOUSE/CONTENTS/VEHICLE).
     */
    export enum risk_type {
        HOUSE = 'HOUSE',
        CONTENTS = 'CONTENTS',
        VEHICLE = 'VEHICLE',
        PERSONAL_LINES_HOME_RISK = 'PERSONAL LINES - HOME RISK',
        PERSONAL_LINES_CONTENTS_RISK = 'PERSONAL LINES - CONTENTS RISK',
        PERSONAL_LINES_VEHICLE_RISK = 'PERSONAL LINES - VEHICLE RISK',
    }
    /**
     * Offering
     */
    export enum offering {
        BLANKET_STANDARD_PERSONAL_LINES = 'Blanket Standard - Personal Lines',
        BLANKET_COMPREHENSIVE_PERSONAL_LINES = 'Blanket Comprehensive - Personal Lines',
        BLANKET_ELITE_PERSONAL_LINES = 'Blanket Elite - Personal Lines',
    }
}

